var React = require('react');

function ChevronUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M20.505 15.462L12.058 6.86l-8.446 8.602","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronUpInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ChevronUpInline;

ChevronUpInline.default = ChevronUpInline;
